import { Link } from "react-router-dom";
import { Code2, Phone, Mail, MapPin, Github, Linkedin, Twitter } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0a0a0f] border-t border-[#2a2a3a]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-[#00d4aa] to-[#0ea5e9] flex items-center justify-center">
                <Code2 className="w-6 h-6 text-[#0a0a0f]" />
              </div>
              <span className="font-mono font-bold text-lg text-[#f0f0f5]">
                BF Code Labs
              </span>
            </Link>
            <p className="text-[#9ca3af] text-sm mb-4 leading-relaxed">
              Modern yazılım çözümleri ile işinizi dijital dünyada güçlendiriyoruz.
            </p>
            <div className="flex gap-3">
              <a
                href="#"
                className="w-9 h-9 rounded-lg bg-[#16161f] border border-[#2a2a3a] flex items-center justify-center text-[#9ca3af] hover:text-[#00d4aa] hover:border-[#00d4aa] transition-all"
                data-testid="social-github"
              >
                <Github className="w-4 h-4" />
              </a>
              <a
                href="#"
                className="w-9 h-9 rounded-lg bg-[#16161f] border border-[#2a2a3a] flex items-center justify-center text-[#9ca3af] hover:text-[#00d4aa] hover:border-[#00d4aa] transition-all"
                data-testid="social-linkedin"
              >
                <Linkedin className="w-4 h-4" />
              </a>
              <a
                href="#"
                className="w-9 h-9 rounded-lg bg-[#16161f] border border-[#2a2a3a] flex items-center justify-center text-[#9ca3af] hover:text-[#00d4aa] hover:border-[#00d4aa] transition-all"
                data-testid="social-twitter"
              >
                <Twitter className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-mono font-semibold text-[#f0f0f5] mb-4 text-sm">
              {'// Hızlı Linkler'}
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="footer-link text-sm" data-testid="footer-home">
                  Ana Sayfa
                </Link>
              </li>
              <li>
                <Link to="/urunler" className="footer-link text-sm" data-testid="footer-products">
                  Ürünler
                </Link>
              </li>
              <li>
                <Link to="/portfolyo" className="footer-link text-sm" data-testid="footer-portfolio">
                  Portföy
                </Link>
              </li>
              <li>
                <Link to="/hakkimizda" className="footer-link text-sm" data-testid="footer-about">
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link to="/iletisim" className="footer-link text-sm" data-testid="footer-contact">
                  İletişim
                </Link>
              </li>
            </ul>
          </div>

          {/* Services - keep as is since these are service descriptions not product links */}
          <div>
            <h4 className="font-mono font-semibold text-[#f0f0f5] mb-4 text-sm">
              {'// Hizmetlerimiz'}
            </h4>
            <ul className="space-y-3">
              <li>
                <span className="text-[#9ca3af] text-sm">
                  Mobil Uygulama
                </span>
              </li>
              <li>
                <span className="text-[#9ca3af] text-sm">
                  Web Geliştirme
                </span>
              </li>
              <li>
                <span className="text-[#9ca3af] text-sm">
                  n8n Projeleri
                </span>
              </li>
              <li>
                <span className="text-[#9ca3af] text-sm">
                  Yapay Zeka Sistemleri
                </span>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-mono font-semibold text-[#f0f0f5] mb-4 text-sm">
              {'// İletişim'}
            </h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-[#9ca3af] text-sm">
                <Phone className="w-4 h-4 text-[#00d4aa]" />
                <a href="tel:+905053862670" className="hover:text-[#00d4aa] transition-colors">
                  +90 505 386 26 70
                </a>
              </li>
              <li className="flex items-center gap-3 text-[#9ca3af] text-sm">
                <Mail className="w-4 h-4 text-[#00d4aa]" />
                <a href="mailto:info@bfcodelabs.com" className="hover:text-[#00d4aa] transition-colors">
                  info@bfcodelabs.com
                </a>
              </li>
              <li className="flex items-start gap-3 text-[#9ca3af] text-sm">
                <MapPin className="w-4 h-4 text-[#00d4aa] mt-0.5" />
                <span>Türkiye</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-[#2a2a3a]">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-[#9ca3af] text-sm font-mono">
              &copy; {currentYear} BF Code Labs. Tüm hakları saklıdır.
            </p>
            <p className="text-[#9ca3af] text-sm font-mono">
              <span className="text-[#00d4aa]">{'<'}</span>
              Murat Tabu
              <span className="text-[#00d4aa]">{' />'}</span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
